import { CRM_CALENDAR_VISIT_PATH, hasCrmVisitPermission } from '../crm/routes';
import {
  hasPrescriptionPermission,
  hasTranscriptionPermission, PRESCRIPTION_PATH,
  TRANSCRIPTION_PATH
} from '../prescription/routes';

//import Home from './screens/index.vue';
const Home = () => import('./screens/index.vue')

const HOME_PATH = '/';

const homeRoute = {
  path: HOME_PATH,
  name: 'home',
  component: Home,
  meta: {
    requiresAuth: true,
    hideFromMenu: true,
  },
  beforeEnter: (to, from, next) => {
    let newPath;   
    if (!!to && to.path === HOME_PATH) {      
      if (hasPrescriptionPermission()) {
        newPath = { path: PRESCRIPTION_PATH };
      } else if (hasTranscriptionPermission()) {
        newPath = { path: TRANSCRIPTION_PATH };
      } else if (hasCrmVisitPermission()) {
        newPath = { path: CRM_CALENDAR_VISIT_PATH };
      }
    }
    next(newPath);
  },
};

export { homeRoute, HOME_PATH };

